// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__g4fXX","reportBodyText":"style__reportBodyText__8+Lhh"};